import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AutoRenewComponent, CustomTooltipDefinition } from 'components';
import { Button, Loading } from 'carbon-components-react';
import Utils from 'utilities/helper.util';
import {
  updateEnquiryById,
  updatingEnquiry,
  enquiryError
} from 'redux/enquiries';
import { CheckmarkFilled16, Misuse16 } from '@carbon/icons-react';
import dayjs from 'dayjs';

export const AutoRenewSection: React.FC<any> = (props: any) => {
  const dispatch = useDispatch();
  const updating: boolean | undefined = useSelector(updatingEnquiry);
  const apiError: any = useSelector(enquiryError);
  const NEXT_28_DAYS_DATE: any = Utils.getDateAfterDays(28);
  const LAST_28_DAYS_DATE: any = Utils.getDateBeforeDays(28);
  const {
    id,
    autoRenewUntil,
    isAutoRenewComplete,
    digEndAt,
    createdAt
  } = props;
  const [autoRenewStatus, setAutoRenewStatus] = useState<string>(
    autoRenewUntil === null || autoRenewUntil === '' ? 'Off' : 'On'
  );
  const [showAutoRenewToggle, setShowAutoRenewToggle] = useState<boolean>(
    false
  );
  const [newAutoRenewUntil, setNewAutoRenewUntil] = useState<any>(
    autoRenewUntil
  );
  const [error, setError] = useState<string>('');
  const [autoRenewToggle, setAutoRenewToggle] = useState<boolean>(
    showAutoRenewToggle
  );
  const [isLoading, setIsLoading] = useState<boolean>();

  const saveAutoRenewHandler = useCallback(() => {
    if (autoRenewToggle && newAutoRenewUntil === null) {
      setError('Auto Renew Until is required');
    } else {
      const payload = {
        enquiryId: id,
        autoRenewUntil: autoRenewToggle
          ? Utils.toDateAPIFormat(newAutoRenewUntil)
          : null
      };

      if (!autoRenewToggle) {
        setNewAutoRenewUntil(null);
      }
      dispatch(updateEnquiryById(payload));
    }
  }, [dispatch, id, autoRenewToggle, newAutoRenewUntil]);

  const updateValuesHandler = useCallback((val) => {
    if (typeof val === 'boolean') {
      setAutoRenewToggle(val);
      if (!val) {
        setNewAutoRenewUntil(null);
      }
    }
    if (typeof val !== 'boolean') {
      setNewAutoRenewUntil(val);
    }
  }, []);

  const initAutoRenewHandler = useCallback(() => {
    setAutoRenewStatus('Save');
    setShowAutoRenewToggle(!showAutoRenewToggle);
  }, [showAutoRenewToggle]);

  useEffect(() => {
    setAutoRenewToggle(autoRenewUntil !== null || autoRenewUntil !== '');
    isAutoRenewComplete && setAutoRenewStatus('View');
  }, [autoRenewUntil, isAutoRenewComplete]);

  /*eslint-disable*/
  useEffect(() => {
    setIsLoading(updating);
    newAutoRenewUntil !== null && setError('');

    if (updating === false) {
      setTimeout(() => {
        setIsLoading(undefined);
        setShowAutoRenewToggle(false);
        setAutoRenewStatus(
          newAutoRenewUntil === null || newAutoRenewUntil === '' ? 'Off' : 'On'
        );
      }, 3000);
    }
  }, [updating]);
  /*eslint-disable*/

  return (
    <>
      {((!dayjs(digEndAt).isBefore(dayjs(NEXT_28_DAYS_DATE)) &&
        !dayjs(createdAt).isBefore(dayjs(LAST_28_DAYS_DATE))) ||
        isAutoRenewComplete) && (
        <>
          <div className="auto-renew">
            <div className="auto-renew--wrap">
              <CustomTooltipDefinition
                tooltipText="For longer jobs you have the option to automatically renew and get fresh plans every 28 days"
                className="auto-renew--text"
              >
                Auto-renew properties
              </CustomTooltipDefinition>
              {autoRenewStatus === 'View' ? (
                <Button
                  className="auto-renew--action"
                  onClick={() => setShowAutoRenewToggle(!showAutoRenewToggle)}
                  kind="ghost"
                  size="small"
                >
                  View
                </Button>
              ) : (
                <>
                  {isLoading === undefined && (
                    <Button
                      className="auto-renew--action"
                      onClick={() =>
                        autoRenewStatus === 'Save'
                          ? saveAutoRenewHandler()
                          : initAutoRenewHandler()
                      }
                      kind="ghost"
                      size="small"
                    >
                      {autoRenewStatus}
                    </Button>
                  )}
                  {isLoading === true && (
                    <Loading
                      small
                      description="Active loading indicator"
                      withOverlay={false}
                      className="icon--loading"
                    />
                  )}
                  {isLoading === false && (
                    <>
                      {apiError ? (
                        <Misuse16 className="icon--error" />
                      ) : (
                        <CheckmarkFilled16 className="icon--success" />
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            {/* Auto Renew */}
            {showAutoRenewToggle && (
              <div className="auto-renew--panel-wrapper">
                <div className="section--divider"></div>
                <AutoRenewComponent
                  readOnlyMode={isAutoRenewComplete || false}
                  jobEndDate={digEndAt}
                  autoRenewUntil={newAutoRenewUntil}
                  autoRenewToggle={autoRenewToggle}
                  updateValues={(val: any) => updateValuesHandler(val)}
                  autoRenewUntilErrors={error}
                  autoRenewTooltipEnabled={false}
                />
              </div>
            )}
          </div>
          <hr className="section--divider" />
        </>
      )}
    </>
  );
};
AutoRenewSection.displayName = 'AutoRenew';
export default AutoRenewSection;
